import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { z } from 'zod';

import { useSliceWrapper } from '~/hooks/use-slice-wrapper';

export const INTAKE_CHANNEL_STORAGE_KEY = 'intake-channel';

type SliceState = {
  isInitialized: boolean;
  selectedChannel: number | null;
  isEditingProgram: boolean;
  isCreatingReport: boolean;
};
const initialState: SliceState = {
  isInitialized: false,
  selectedChannel: 0,
  isEditingProgram: false,
  isCreatingReport: false,
};

export const intakeChannelSlice = createSlice({
  name: 'intakeChannelData',
  initialState,
  reducers: {
    init: (state) => {
      const id = z.coerce
        .number()
        .catch(0)
        .parse(localStorage.getItem(INTAKE_CHANNEL_STORAGE_KEY));
      state.isInitialized = true;
      state.selectedChannel = id;
    },
    reset: () => {
      return { ...initialState, selectedChannel: 0 };
    },
    setSelectedChannel: (state, action: PayloadAction<number>) => {
      localStorage.setItem(INTAKE_CHANNEL_STORAGE_KEY, String(action.payload));
      state.selectedChannel = action.payload;
    },
    clearSelectedChannel: (state) => {
      localStorage.removeItem(INTAKE_CHANNEL_STORAGE_KEY);
      state.selectedChannel = null;
    },
    setIsEditingProgram: (state, action: PayloadAction<boolean>) => {
      state.isEditingProgram = action.payload;
    },
    setIsCreatingReport: (state, action: PayloadAction<boolean>) => {
      state.isCreatingReport = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedChannel, setIsEditingProgram, setIsCreatingReport } =
  intakeChannelSlice.actions;

export const useIntakeChannel = () =>
  useSliceWrapper(intakeChannelSlice, 'intakeChannelData');

export const IntakeChannelSlice = intakeChannelSlice;

export default intakeChannelSlice.reducer;
